import TeamRoleType from "@/constants/TeamRoleType";
import CommitmentFilterType from "@/constants/CommitmentFilterType";
import GoalType from "@/constants/GoalType";

export default {
	// Teams
	Teams_header_title: "My Teams",
	Teams_teamTab_label: "My Teams",
	Teams_oneOnOneTab_label: "My 1:1s",

	OneOnOnes_header_title: "1:1 Relationships",

	// TeamEditPage
	TeamEditPage_link_text: "Teams",
	TeamEditPage_teamMembers_text: "Team Members",
	TeamEditPage_inviteConfirmation_headerText: "Removing a Team Member",
	TeamEditPage_inviteConfirmation_bodyText: "Remove {memberName} from {teamName}?",
	TeamEditPage_inviteDuplicate_headerText: "",
	TeamEditPage_inviteDuplicate_bodyText_invited: "{memberName} has already been invited to {teamName}",
	TeamEditPage_inviteDuplicate_bodyText_active: "{memberName} is already a member of {teamName}",
	TeamEditPage_inviteDuplicate_confirmButtonText: "OK",
	TeamEditPage_removalError_confirmButtonText: "OK",
	TeamEditPage_onlyLeadRemovalError_headerText: "Cannot Remove Team Member",
	TeamEditPage_onlyLeadRemovalError_bodyText: "{memberName} is the only team lead for {teamName}.<br/><br/>Please make another active team member lead before removing them.",
	TeamEditPage_roleChangeError_confirmButtonText: "OK",
	TeamEditPage_onlyLeadRoleChangeError_headerText: "Cannot Change Role",
	TeamEditPage_onlyLeadRoleChangeError_bodyText: "{memberName} is the only team lead for {teamName}.<br/><br/>Please make another active team member lead before changing their role.",

	// TeamInvite
	TeamInvite_inviteeEmail_invalidError: "Please enter a valid email address.",
	TeamInvite_inviteeEmail_title: "Add Team Members",
	TeamInvite_inviteeEmail_hint: "Enter the email address of the person you'd like to add",
	TeamInvite_inviteeEmail_label: "Email",
	TeamInvite_inviteeCheckbox_label: "Create 1:1 with this teammate",
	TeamInvite_inviteButton_label: "Invite",

	// TeamNameEdit
	TeamNameEdit_teamNameTooLong_invalidError: "Team name must be less than 255 characters",
	TeamNameEdit_teamNameNotPresent_invalidError: "Team name must be less than 255 characters",

	// TeamWorkStyle
	TeamWorkStyle_headerText: "Work Style Distribution",
	TeamWorkStyle_descriptionHeader: "Team Summary",
	TeamWorkStyle_strengthsSectionHeader: "Strengths Tendencies",
	TeamWorkStyle_blindspotsSectionHeader: "Blind Spot Tendencies",
	TeamWorkStyle_missingTeamMemberAssessmentsText: "Some of your active team members have not taken the work style assessment. For the most accurate results, we recommend 100% participation.",
	TeamWorkStyle_unlockTeamMemberAssessmentsText: "To unlock the team work style summary, at least two team members must complete their individual work style assessments.",

	// routes
	routes_teameditpage_title: "Team",

	// store
	TeamEditPage_LEAD_roleLabelText: "Lead",
	TeamEditPage_MEMBER_roleLabelText: "Member",
	TeamEditPage_ACTIVE_statusLabelText: "Active",

	TeamEditPage_INVITED_statusLabelText: "Invited",
	TeamInvite_SuccessMessage: "Successfully invited {email}",
	TeamInvite_ErrorMessage: "An unexpected error occurred while inviting someone to your team: {error}",
	TeamInvite_OneOnOneErrorMessage: "An unexpected error occurred while creating a 1:1 with your teammate: {error}",
	TeamEditPage_loading_ErrorMessage: "An unexpected error occurred while loading your team: {error}",
	TeamEditPage_removingMember_SuccessMessage: "Team member removed successfully",
	TeamEditPage_removingMember_ErrorMessage: "An unexpected error occurred while removing team member: {error}",
	TeamEditPage_updatingMember_SuccessMessage: "Team member updated successfully",
	TeamEditPage_updatingMember_ErrorMessage: "An unexpected error occurred while updating team member: {error}",
	TeamEditPage_updatingTeamName_SuccessMessage: "Team name updated successfully",
	TeamEditPage_updatingTeamName_ErrorMessage: "An unexpected error occurred while updating team name: {error}",
	TeamEditPage_PENDING_statusLabelText: "Pending",
	TeamEditPage_teamOverviewTabText: "Overview",
	TeamEditPage_teamMembersTabText: "Members",
	TeamEditPage_teamWorkStyleTabText: "Work Style",
	TeamEditPage_teamHealthTabText: "Team Health",
	TeamEditPage_teamGoalsTabText: "Goals",
	TeamEditPage_teamCommitmentsTabText: "Action Items",

	// TeamGrid
	TeamGrid_header_nameColumn: "Team Name",
	TeamGrid_header_leadsColumn: "Team Lead(s)",
	TeamGrid_header_membersColumn: "Team Members",
	TeamGrid_teamFilterPlaceholder: "My Teams",
	TeamGrid_teamFilter_myTeamsOption: "My Teams",
	TeamGrid_teamFilter_otherTeamsOption: "Other Teams",
	TeamGrid_newTeamButton: "New Team",
	TeamGrid_acceptInviteButton: "Accept",
	TeamGrid_rejectInviteButton: "Decline",
	TeamGrid_noTeamsMessage: "You have no teams. Please create one!",
	TeamGrid_errorFavoritingTeam: "An error occurred while favoriting a team: {message}",
	TeamGrid_errorUnfavoritingTeam: "An error occurred while unfavoriting a team: {message}",

	// TeamMemberRow
	TeamMemberRow_leaveTeam_menuText: "Leave team",
	TeamMemberRow_createOneOnOne_menuText: "Create 1:1",
	TeamMemberRow_removeFromTeam_menuText: "Remove from team",
	[ TeamRoleType.LEAD ]: "Lead",
	[ TeamRoleType.MEMBER ]: "Member",

	//
	// TeamGoals
	//
	[ `TeamGoals_${GoalType.ACTIVE}LoadingPlaceholderTitle` ]: "Attempting to load active team goals. Please wait.",
	[ `TeamGoals_${GoalType.ACTIVE}PlaceholderTitle` ]: "Looks like your team doesn’t have any active goals.",
	[ `TeamGoals_${GoalType.ACTIVE}PlaceholderDescription` ]: "Create team goals to keep your team focused on the work that matters, and track your progress toward meaningful results.",
	[ `TeamGoals_${GoalType.DRAFT}LoadingPlaceholderTitle` ]: "Attempting to load draft team goals. Please wait.",
	[ `TeamGoals_${GoalType.DRAFT}PlaceholderTitle` ]: "No draft goals.",
	[ `TeamGoals_${GoalType.DRAFT}PlaceholderDescription` ]: "Use this space to draft goals you’re not quite ready to track.",
	[ `TeamGoals_${GoalType.ARCHIVED}LoadingPlaceholderTitle` ]: "Attempting to load archived team goals. Please wait.",
	[ `TeamGoals_${GoalType.ARCHIVED}PlaceholderTitle` ]: "No archived goals.",
	[ `TeamGoals_${GoalType.ARCHIVED}PlaceholderDescription` ]: "When you’re finished tracking a goal, archive it and we’ll save it here just in case you need to reference it later.",
	TeamGoals_detailsColumn: "Details",
	TeamGoals_progressColumn: "KR Progress",
	TeamGoals_updatedColumn: "", // intentionally empty
	[ `TeamGoals_${GoalType.ACTIVE}Label` ]: "Active",
	[ `TeamGoals_${GoalType.DRAFT}Label` ]: "Draft",
	[ `TeamGoals_${GoalType.ARCHIVED}Label` ]: "Archive",

	//
	// TeamCommitments
	//
	TeamCommitments_openCommitmentsHeading: "Open action items",
	TeamCommitments_overdueCommitmentsHeading: "Overdue action items",
	TeamCommitments_noDueDateCommitmentsHeading: "Action items with no due date",
	TeamCommitments_dueInNextWeekCommitmentsHeading: "Action items due within 7 days",
	TeamCommitments_completedCommitmentsHeading: "Completed action items",

	//
	// CommitmentFilters
	//
	[ `CommitmentFilters_${CommitmentFilterType.COMPLETE}Label` ]: "Completed",
	[ `CommitmentFilters_${CommitmentFilterType.DUE_IN_NEXT_WEEK}Label` ]: "Due within 7 days",
	[ `CommitmentFilters_${CommitmentFilterType.NO_DUE_DATE}Label` ]: "No due date",
	[ `CommitmentFilters_${CommitmentFilterType.OUTSTANDING}Label` ]: "Open",
	[ `CommitmentFilters_${CommitmentFilterType.OVERDUE}Label` ]: "Overdue",

	//
	// GoalsPlaceholder
	//
	GoalsPlaceholder_heading: "Looks like your team doesn’t have any active goals.",
	GoalsPlaceholder_body: "Create team goals to keep your team focused on work that matters, tracking progress toward meaningful results.",

	//
	// GoalsCard
	//
	GoalsCard_title: "Team Goals",
	GoalsCard_createButtonText: "Create team goals",
	GoalsCard_updateOrAddButtonText: "Update or add goals",

	//
	// MeetingsPlaceholder
	//
	MeetingsPlaceholder_upcomingHeading: "No upcoming team meetings",
	MeetingsPlaceholder_recentHeading: "No recent team meetings",
	MeetingsPlaceholder_body: "There are no meetings connected to this team within the next 7 days. If you think this is a mistake, <a href=\"/schedule\">check your meeting schedule</a> to make sure there are no meetings that need to be connected to this team.",
	MeetingsPlaceholder_connectButtonText: "Connect a meeting",

	//
	// MeetingsCard
	//
	MeetingsCard_title: "Team Meetings",
	MeetingsCard_connectButtonText: "Connect a meeting",
	MeetingsCard_upcomingButtonText: "Upcoming",
	MeetingsCard_recentButtonText: "Recent",

	//
	// MeetingCard
	//
	MeetingCard_todayLabel: "Today",
	MeetingCard_tomorrowLabel: "Tomorrow",
	MeetingCard_yesterdayLabel: "Yesterday",
	MeetingCard_addTopicsButtonText: "Add topics",
	MeetingCard_joinButtonText: "Join",
	MeetingCard_viewReportButtonText: "View report",

	//
	// TopicsRequestedChip
	//
	TopicsRequestedChip_topicsRequestedLabel: "Topics requested",

	//
	// NoTopicsChip
	//
	NoTopicsChip_noTopicsLabel: "No topics",

	//
	// NoOutcomesChip
	//
	NoOutcomesChip_noOutcomesLabel: "No outcomes",

	//
	// CommitmentsPlaceholder
	//
	CommitmentsPlaceholder_heading: "Your team has no action items.",
	CommitmentsPlaceholder_body: "Action Items are tasks assigned to individual team members. We recommend adding them as outcomes during your team meetings, but they can also be created and assigned here on your team page.",

	//
	// CommitmentsCard
	//
	CommitmentsCard_title: "Action Items",
	CommitmentsCard_viewCommitmentsButtonText: "View action items",

	//
	// RecentDecisionsPlaceholder
	//
	RecentDecisionsPlaceholder_heading: "No recent decisions.",
	RecentDecisionsPlaceholder_body: "You can log team decisions as outcomes during your team meetings.",

	//
	// RecentDecisionsCard
	//
	RecentDecisionsCard_title: "Recent Decisions",

	//
	// DynamicPlaceholder
	//
	DynamicPlaceholder_heading: "Waiting for assessments",
	DynamicPlaceholder_body: "To unlock the team work style summary, a minimum of two team members must complete their individual work style assessments.",

	//
	// DynamicsCard
	//
	DynamicCard_title: "Team Dynamic",
	DynamicCard_viewAllButtonText: "View all strengths & blind spots",

	//
	// NoHealthSurveyPlaceholder
	//
	NoHealthSurveyPlaceholder_teamLeadBody: "Send a brief survey to your team to measure the health of your team across seven key dimensions. Results will promote a shared understanding of team health, and we’ll offer coaching that help you make improvements that benefit everyone on the team.",
	NoHealthSurveyPlaceholder_teamMemberBody: "Your team lead will send a brief survey to measure the health of the team across seven key dimensions. Results will promote a shared understanding of team health, and we’ll offer coaching that help the team make improvements beneficial to everyone.",

	//
	// HealthCard
	//
	HealthCard_title: "Team Health",
	HealthCard_startYourFirstSurveyButtonText: "Start your first survey",
	HealthCard_learnMoreButtonText: "Learn more",
	HealthCard_viewFullReportButtonText: "View full report",

	//
	// CommitmentPlaceholder
	//
	[ `CommitmentPlaceholder_${CommitmentFilterType.COMPLETE}Heading` ]: "Your team hasn’t completed any action items yet.",
	[ `CommitmentPlaceholder_${CommitmentFilterType.DUE_IN_NEXT_WEEK}Heading` ]: "Your team has no action items due within the next 7 days.",
	[ `CommitmentPlaceholder_${CommitmentFilterType.NO_DUE_DATE}Heading` ]: "Your team has no action items without due dates.",
	[ `CommitmentPlaceholder_${CommitmentFilterType.OUTSTANDING}Heading` ]: "Your team doesn’t have any open action items.",
	[ `CommitmentPlaceholder_${CommitmentFilterType.OVERDUE}Heading` ]: "Your team has no overdue action items.",

	[ `CommitmentPlaceholder_${CommitmentFilterType.COMPLETE}Text` ]: "Action items will be archived here as you and your team complete them. If any are completed prematurely, you’ll be able to uncheck them here. ",
	[ `CommitmentPlaceholder_${CommitmentFilterType.DUE_IN_NEXT_WEEK}Text` ]: "Be sure to capture any action items during your team meetings.",
	[ `CommitmentPlaceholder_${CommitmentFilterType.NO_DUE_DATE}Text` ]: "Great job. Always assign dates to your action items to keep work on track.",
	[ `CommitmentPlaceholder_${CommitmentFilterType.OUTSTANDING}Text` ]: "Action items can be added as outcomes during your team meetings.",
	[ `CommitmentPlaceholder_${CommitmentFilterType.OVERDUE}Text` ]: "Nice job keeping your work on track!",

	//
	// DynamicSBS
	//
	DynamicSBS_strengthHeading: "Team Strength",
	DynamicSBS_blindSpotHeading: "Blind Spot!",

	//
	// DynamicGroups
	//
	DynamicGroups_plusOthersLabel: "...plus {count} others",

	//
	// LoadingPlaceholder
	//
	LoadingPlaceholder_pleaseWaitMessage: "Please Wait",

	//
	// InProgressHealthSurveyPlaceholder
	//
	InProgressHealthSurveyPlaceholder_heading: "Survey in progress",
	InProgressHealthSurveyPlaceholder_completedSurveyBody: "When the survey is completed by all team members, we’ll show a summary of results here.",
	InProgressHealthSurveyPlaceholder_incompleteSurveyBody: "Looks like you haven’t completed the in progress survey. When the survey is completed by all team members, we’ll show a summary of results here.",
	InProgressHealthSurveyPlaceholder_completedSurveyButton: "Check progress",
	InProgressHealthSurveyPlaceholder_incompleteSurveyButton: "Answer survey",


};



// WEBPACK FOOTER //
// ./src/lang/en/teamManagement.js